export const removeTrailingSlash = (str: string = '') => str.replace(/\/+$/, '')
export const removeQueryParams = (str: string = '') => str.replace(/(\?.*)|(#.*)/g, '')

export function safeParse<T>(input: string | undefined): T | null {
  try {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return JSON.parse(input || 'null') as T
  } catch (e) {
    return null
  }
}

export function safeQueryParamParse<T = any>(input?: string | null) {
  try {
    return safeParse(atob(decodeURIComponent(input ?? ''))) as T
  } catch (error) {
    return null
  }
}

/** Converts all email addresses in a string to mailto links */
export function createEmailLinks(text: string = '') {
  const emailPattern = /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi
  return text.replace(emailPattern, (match) => `<a href="mailto:${match}">${match}</a>`)
}
